// ResExpiredStore.js
// Same tiny framework-agnostic store pattern as RateLimitStore.js — lets AxiosConfig.js (outside
// any React component) trigger a popup that ResExpiredOverlay.jsx (mounted once, globally, in
// App.js) picks up via useSyncExternalStore. Added per explicit instruction ("whenevr this error
// comes in any module, then show the popup ... whenever this api call's response is RES_EXPIRED")
// — every combined-fees/Hold call across every module already returns this exact
// {code: "RES_EXPIRED", CodeName, Message} shape on a stale/pruned FlightSearchResult row (see
// MainHoldController::holdTheFlight() and every *CombinedFees() action in
// MainSearchController.php), so catching it in ONE place (the shared axios interceptor) covers
// every module automatically instead of needing a try/catch in each call site.
import { useSyncExternalStore } from "react";

let state = {
  isShown: false,
  message: null,
};

const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener());
}

export function getResExpiredState() {
  return state;
}

export function subscribeResExpired(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Called from AxiosConfig.js's response interceptor whenever ANY api call's error response body
// has code === "RES_EXPIRED" — message falls back to the same default text used elsewhere
// (BottomBar/index.js's own bookLoadingErrorMessage fallback) if the backend ever omits it.
export function triggerResExpired(message) {
  state = {
    isShown: true,
    message: message || "Your flight results are expired, please do a fresh search for latest low fares",
  };
  emit();
}

export function clearResExpired() {
  state = { isShown: false, message: null };
  emit();
}

export function useResExpiredState() {
  return useSyncExternalStore(subscribeResExpired, getResExpiredState);
}
